/* eslint:disabled */
import { Box, Tab, Tabs } from '@mui/material'
import { useSession } from 'components/Providers'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { hasPermission } from 'store'
import 'utils/global.scss'

 
export const tabConfig = [
     {
      index: 0,
      label: "Calendar",
      path: "calendar",
      permission: 'setting.calendar',
      visibleAtCampus: false,
      visibleAtProvider: true
    },
     {
      index: 1,
      label: "Academic Year",
      path: "academic-year",
      permission: 'setting.academic',
      visibleAtCampus: false,
      visibleAtProvider: true
    },
     {
      index: 2,
      label: "School Access",
      path: "school-access",
      permission: 'setting.access',
      disabled: false,
      visibleAtCampus: false,
      visibleAtProvider: true

    },
     {
      index: 3,
      label: "School Management",
      path: "school-management",
      permission: 'setting.district',
      visibleAtCampus: false,
      visibleAtProvider: true
    },
      {
    index: 4,
    label: "Grade Sections",
    path: "grade-sections",
    permission: 'setting.section',
    visibleAtCampus: true,
    visibleAtProvider: false
  },
  {
    index: 5,
    label: "Rooms",
    path: "rooms",
    permission: 'setting.room',
    visibleAtCampus: true,
    visibleAtProvider: true
  },
  {
    index: 6,
    label: "Periods",
    path: "periods",
    permission: 'setting.period',
    visibleAtCampus: true,
    visibleAtProvider: false
  },
  {
    index: 7,
    label: "Grading",
    path: "grading",
    permission: 'setting.grading',
    visibleAtCampus: true,
    visibleAtProvider: false
  },
  {
    index: 8,
    label: "Marking Periods",
    path: "marking-periods",
    permission: 'setting.setting',
    visibleAtCampus: true,
    visibleAtProvider: false
  },
  ]

export default function SettingsTabs() {
  const { t } = useTranslation()
  const theme = useSelector(state => state.session.appearance)
  const { '*': tabName } = useParams()
  const { district } = useSession()
  const permittedTabs = tabConfig.filter(tab =>
    hasPermission(tab.permission) &&
    (district?.isServiceProvider && tab.visibleAtProvider || !district?.isServiceProvider && tab.visibleAtCampus)
  );

  const getTabIndex = path => {
    const [tabName] = path.split("/");
    const found = permittedTabs.find(tab => tab.path === tabName);
    return found ? found.index : permittedTabs[0]?.index ?? 0;
  };
  const [tabIndex, setTabIndex] = useState(getTabIndex(tabName))

  useEffect(() => {
    setTabIndex(getTabIndex(tabName));
  }, [tabName, permittedTabs.length]);

  const basePath = `/settings`

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', displayPrint: 'none' }}>
        <Tabs value={tabIndex}>
          {permittedTabs.map(tab => (
            <Tab
              key={tab.path}
              sx={{ color: tabIndex === tab.index && "primary !important" }}
              className={tabIndex === tab.index
                ? `tab-item-selected`
                : `tab-item-${theme}`
              }
              label={t(tab.label)}
              value={tab.index}
              component={Link}
              to={`${basePath}/${tab.path}`}
              disabled={tab.disabled}
            />
          ))}
        </Tabs>
      </Box>
    </Box>
  )
}
